import AddressesValidator from './AddressesValidator';
import AddressHistoryValidator from './AddressHistoryValidator';
import AfterValidator from './AfterValidator';
import AppropriatenessValidator from './AppropriatenessValidator';
import BankAccountsOrDeferredValidator from './BankAccountsOrDeferredValidator';
import BankAccountsValidator from './BankAccountsValidator';
import BeforeValidator from './BeforeValidator';
import BetweenValidator from './BetweenValidator';
import CountryValidator from './CountryValidator';
import DateValidator from './DateValidator';
import DayValidator from './DayValidator';
import EmailValidator from './EmailValidator';
import FileValidator from './FileValidator';
import IbanValidator from './IbanValidator';
import ImageValidator from './ImageValidator';
import IntegerValidator from './IntegerValidator';
import IsFalseValidator from './IsFalseValidator';
import IsTrueValidator from './IsTrueValidator';
import LessValidator from './LessValidator';
import MaxValidator from './MaxValidator';
import MinValidator from './MinValidator';
import MoneyValidator from './MoneyValidator';
import MonthValidator from './MonthValidator';
import MoreValidator from './MoreValidator';
import NationalInsuranceNumberValidator from './NationalInsuranceNumberValidator';
import NationalInsuranceOrTaxReferenceValidator from './NationalInsuranceOrTaxReferenceValidator';
import PhoneNumbersValidator from './PhoneNumbersValidator';
import PhoneNumberValidator from './PhoneNumberValidator';
import PostcodeValidator from './PostcodeValidator';
import QuestionValidator from './QuestionValidator';
import RequiredValidator from './RequiredValidator';
import SortCodeValidator from './SortCodeValidator';
import TiptapValidator from './TiptapValidator';
import UrlValidator from './UrlValidator';
import UtrValidator from './UtrValidator';
import UuidValidator from './UuidValidator';
import YearValidator from './YearValidator';
import YouTubeUrlValidator from './YouTubeUrlValidator';
import TaxReferenceValidator from './TaxReferenceValidator';

export const validators = {
    [AddressesValidator.key]: AddressesValidator.validator,
    [AddressHistoryValidator.key]: AddressHistoryValidator.validator,
    [AfterValidator.key]: AfterValidator.validator,
    [AppropriatenessValidator.key]: AppropriatenessValidator.validator,
    [BankAccountsValidator.key]: BankAccountsValidator.validator,
    [BankAccountsOrDeferredValidator.key]: BankAccountsOrDeferredValidator.validator,
    [BeforeValidator.key]: BeforeValidator.validator,
    [BetweenValidator.key]: BetweenValidator.validator,
    [DateValidator.key]: DateValidator.validator,
    [CountryValidator.key]: CountryValidator.validator,
    [DayValidator.key]: DayValidator.validator,
    [EmailValidator.key]: EmailValidator.validator,
    [FileValidator.key]: FileValidator.validator,
    [IbanValidator.key]: IbanValidator.validator,
    [ImageValidator.key]: ImageValidator.validator,
    [IntegerValidator.key]: IntegerValidator.validator,
    [IsFalseValidator.key]: IsFalseValidator.validator,
    [IsTrueValidator.key]: IsTrueValidator.validator,
    [MaxValidator.key]: MaxValidator.validator,
    [LessValidator.key]: LessValidator.validator,
    [MinValidator.key]: MinValidator.validator,
    [MoreValidator.key]: MoreValidator.validator,
    [MoneyValidator.key]: MoneyValidator.validator,
    [MonthValidator.key]: MonthValidator.validator,
    [NationalInsuranceNumberValidator.key]: NationalInsuranceNumberValidator.validator,
    [NationalInsuranceOrTaxReferenceValidator.key]: NationalInsuranceOrTaxReferenceValidator.validator,
    [PhoneNumberValidator.key]: PhoneNumberValidator.validator,
    [PhoneNumbersValidator.key]: PhoneNumbersValidator.validator,
    [PostcodeValidator.key]: PostcodeValidator.validator,
    [QuestionValidator.key]: QuestionValidator.validator,
    [RequiredValidator.key]: RequiredValidator.validator,
    [SortCodeValidator.key]: SortCodeValidator.validator,
    [TiptapValidator.key]: TiptapValidator.validator,
    [UrlValidator.key]: UrlValidator.validator,
    [UtrValidator.key]: UtrValidator.validator,
    [UuidValidator.key]: UuidValidator.validator,
    [YearValidator.key]: YearValidator.validator,
    [YouTubeUrlValidator.key]: YouTubeUrlValidator.validator,
    [TaxReferenceValidator.key]: TaxReferenceValidator.validator
};

export default validators;

export const fieldValidators = {
    [AfterValidator.key]: AfterValidator,
    [BeforeValidator.key]: BeforeValidator,
    [BetweenValidator.key]: BetweenValidator,
    [DateValidator.key]: DateValidator,
    [CountryValidator.key]: CountryValidator,
    [DayValidator.key]: DayValidator,
    [EmailValidator.key]: EmailValidator,
    [FileValidator.key]: FileValidator,
    [IbanValidator.key]: IbanValidator,
    [ImageValidator.key]: ImageValidator,
    [IntegerValidator.key]: IntegerValidator,
    [IsFalseValidator.key]: IsFalseValidator,
    [IsTrueValidator.key]: IsTrueValidator,
    [MaxValidator.key]: MaxValidator,
    [MinValidator.key]: MinValidator,
    [MoneyValidator.key]: MoneyValidator,
    [MonthValidator.key]: MonthValidator,
    [NationalInsuranceNumberValidator.key]: NationalInsuranceNumberValidator,
    [PhoneNumberValidator.key]: PhoneNumberValidator,
    [PostcodeValidator.key]: PostcodeValidator,
    [RequiredValidator.key]: RequiredValidator,
    [SortCodeValidator.key]: SortCodeValidator,
    [UrlValidator.key]: UrlValidator,
    [UtrValidator.key]: UtrValidator,
    [UuidValidator.key]: UuidValidator,
    [YearValidator.key]: YearValidator
};

/**
 * Get a validation rule validator function
 * @param {String} key
 * @returns {Function}
 */
export const getValidator = key => {
    if (typeof key !== 'string') {
        throw new Error('getValidator: key must be a string');
    }

    if (!validators[`${key}`]) {
        throw new Error(`getValidator: validator "${key}" does not exist`);
    }

    return validators[`${key}`];
};

/**
 * Get a validation rule validator function
 * @param {String} validationConfig
 * @returns {{validator: Function, args: Array}}
 */
export const getValidatorFromString = validationConfig => {
    let validator = () => false;
    let args = [];

    // e.g. { validationConfig: true }
    if (validationConfig === true || validationConfig === 'true') {
        validator = value => value === true;
    }

    // e.g. { validationConfig: false }
    else if (validationConfig === false || validationConfig === 'false') {
        validator = value => value === false;
    }

    // e.g. { validationConfig: 'required' }
    //      { validationConfig: 'max:3' }
    //      { validationConfig: () => customValidator() }
    else {
        const split = validationConfig.split(':');

        if (split.length > 1) {
            args = split[1].split(',');
        }

        if (typeof split[0] === 'string') {
            validator = getValidator(split[0]);
        } else if (typeof split[0] === 'function') {
            validator = split[0];
        }
    }

    return { validator, args };
};

/**
 * Parses validation errors from a standardized format into a more readable and usable structure.
 *
 * @param {Array<Object>} errors - An array of error objects, typically from a validation library.
 * @param {boolean} removeFirstLoc - If true, the first element of the 'loc' array will be removed.
 * @returns {Array<Object>} An array of parsed error objects, each with 'name', 'field', 'message', and 'type'.
 */
export const parseValidationErrors = (errors, removeFirstLoc = true) => {
    if (!Array.isArray(errors)) {
        return [];
    }

    let parsed = errors.map(error => {
        let parts = [];

        if (removeFirstLoc) {
            parts = error.loc ? error.loc.filter((p, i) => i !== 0) : [];
        } else {
            parts = error.loc ? error.loc : [];
        }

        let name = null;
        const field = parts.join('.');
        const message = error.msg;
        const type = error.type;

        try {
            name =
                error.msg +
                ' for ' +
                parts
                    .reverse()
                    .map(part => {
                        if (!isNaN(parseInt(part))) {
                            return `on row ${parseInt(part) + 1} of`;
                        }

                        return part.replace('_', ' ');
                    })
                    .join(' ');
        } catch (error) {
            name = message + ' for ' + field;
        }

        name = name.charAt(0).toUpperCase() + name.slice(1) + '.';

        return { name, field, message, type };
    });

    return parsed;
};
